
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useMeldingStore = defineStore('melding', () => {
    const isCancelled = ref(false);
    const moveBack = ref(false);

    function setCurrentMelding(melding) {
        isCancelled.value = false;
        localStorage.setItem('currentMelding', JSON.stringify(melding));
    }
    function getCurrentMelding() {
        return JSON.parse(localStorage.getItem('currentMelding'));
    }
    function cancelCurrentMelding() {
        isCancelled.value = true;
    }
    function moveBackCurrentMelding() {
        moveBack.value = true;
    }
    function setSelectedMelding(melding) {
        localStorage.setItem('selectedMelding', JSON.stringify(melding));
    }
    function getSelectedMelding() {
        return JSON.parse(localStorage.getItem('selectedMelding'));
    }

    return {
        isCancelled,
        moveBack,
        setCurrentMelding,
        getCurrentMelding,
        cancelCurrentMelding,
        moveBackCurrentMelding,
        setSelectedMelding,
        getSelectedMelding
    };
});